/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PosCustomerMasterGrid extends _Ext.GridBase<PosCustomerMasterRow, any> {
        protected getColumnsKey() { return 'OMS.PosCustomerMaster'; }
        protected getDialogType() { return PosCustomerMasterDialog; }
        protected getIdProperty() { return PosCustomerMasterRow.idProperty; }
        protected getInsertPermission() { return PosCustomerMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return PosCustomerMasterRow.localTextPrefix; }
        protected getService() { return PosCustomerMasterService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            var code = FormatHelper.GetFormats("POSCustomer");
            this.editItem(<PosCustomerMasterRow>{
                PosCustomerCode: code
            });
        }

    }
}